<div class="content">
    <h2 data-qa="tnb-sub-header">Netzzuordnungen</h2>
    <redispatch-netzzuordnungen-list></redispatch-netzzuordnungen-list>
</div>
